import React from 'react';
// import PropTypes from 'prop-types';

// import Title from '../partials/Title';
import EventCards from '../partials/EventCards';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/tickets.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const TicketsPage = ({ page }) => (
    <div className={styles.container}>
        <div className={styles.inner}>
            <EventCards items={page.children} />
        </div>
    </div>
);

TicketsPage.propTypes = propTypes;

export default TicketsPage;
